/** @format */

export enum FontFamily {
  openSans = "'Open Sans', sans-serif",
}
